import type { ClipboardEvent } from "react";

export function trimPastedText(e: ClipboardEvent<HTMLInputElement>) {
    const el = e.currentTarget;
    // selectionStart is null for input types without selection support (email, number); the browser handles those
    if (el.readOnly || el.disabled || el.selectionStart === null) {
        return;
    }

    const text = e.clipboardData.getData("text/plain");
    const trimmed = text.trim();
    if (trimmed === text || trimmed === "") {
        return;
    }

    e.preventDefault();

    const start = el.selectionStart;
    const end = el.selectionEnd ?? start;
    const remaining =
        el.maxLength >= 0
            ? Math.max(0, el.maxLength - (el.value.length - (end - start)))
            : trimmed.length;
    const inserted = trimmed.slice(0, remaining);
    const value = el.value.slice(0, start) + inserted + el.value.slice(end);

    // the prototype setter bypasses React's value tracker, so the input event below reaches onChange
    Object.getOwnPropertyDescriptor(
        HTMLInputElement.prototype,
        "value",
    )?.set?.call(el, value);
    el.dispatchEvent(new Event("input", { bubbles: true }));

    const caret = start + inserted.length;
    el.setSelectionRange(caret, caret);
}
